// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest {
    static getAttributeTypeMap() {
        return CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest.attributeTypeMap;
    }
}
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest.discriminator = undefined;
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest.additionalProperties = false;
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest.attributeTypeMap = [
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
];
//# sourceMappingURL=couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest.js.map